import { FC } from 'react';

import { ButtonsWrapper, CancelButton, ModalTitle, ModalWrapper, UpgradeButton } from '../StorageErrorModal/Wrapper';

export type ActionType = 'stream' | 'upload';

type ComponentProps = {
  onClose: () => void;
  onProceed?: () => void;
};

const NotStableWarningModal: FC<ComponentProps> = ({ onProceed, onClose }) => {
  const onConfirm = () => {
    onClose();
    onProceed?.();
  };

  return (
    <ModalWrapper onModalClose={onClose}>
      <ModalTitle
        title="This video is currently under processing"
        description="Streaming it at this stage might lead to performance issues, including jittering and slowdowns. We recommend waiting until the processing is complete for an optimal viewing experience. "
      />
      <ButtonsWrapper>
        <CancelButton variant="white-blue-border-share" size="medium" onClick={onClose}>
          Cancel
        </CancelButton>
        <UpgradeButton variant="light-blue" size="medium" onClick={onConfirm}>
          Stream at my own risk
        </UpgradeButton>
      </ButtonsWrapper>
    </ModalWrapper>
  );
};

export default NotStableWarningModal;
